import { useCallback, useEffect, useState } from "react";
import * as api from "../../api";

const num = n => String(Math.round(Number(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
const ESTADO = { abierta: "Abierta", en_curso: "En curso", bloqueada: "Bloqueada", cerrada: "Hecha" };
const PRIO = ["Baja", "Media", "Alta", "Crítica"];
const diaCorto = f => {
  const d = f ? new Date(`${String(f).slice(0, 10)}T12:00:00`) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString("es-ES", { weekday: "short", day: "numeric", month: "short" }).replace(".", "") : "—";
};

// Las tareas SUYAS que han aparecido en una lista de Notion en modo manual y aun no estan en Tareas (T-144, contrato E3):
// «Añadir las N nuevas» las trae todas; «Elegir cuáles» deja marcar. Nada entra sin pulsar. onAnadidas() recarga Tareas.
export default function NuevasDeNotion({ onAnadidas, showToast, recarga = 0 }) {
  const [listas, setListas] = useState([]);
  const [abierta, setAbierta] = useState(null);       // fuente_id con la lista de candidatas abierta
  const [marcadas, setMarcadas] = useState({});       // id -> bool
  const [ocupada, setOcupada] = useState(null);
  const [fallo, setFallo] = useState(null);

  const cargar = useCallback(() => api.fuentesNuevasNotion()
    .then(d => setListas((d.items || []).filter(l => l.modo === "manual" && (l.n > 0 || l.error))))
    .catch(() => setListas([])), []);
  useEffect(() => { cargar(); }, [cargar, recarga]);

  const anadir = async (l, ids) => {
    setOcupada(l.fuente_id); setFallo(null);
    try {
      const r = await api.anadirDesdeNotion({ ids, fuente_id: l.fuente_id });
      showToast?.(`${num(r.añadidas ?? ids.length)} ${(r.añadidas ?? ids.length) === 1 ? "tarea añadida" : "tareas añadidas"} desde «${l.nombre}»`);
      setAbierta(null);
      await cargar();
      onAnadidas?.();
    } catch (e) {
      setFallo({ id: l.fuente_id, mensaje: e?.message || "No se han podido añadir" });
    } finally { setOcupada(null); }
  };

  const abrir = l => { setAbierta(abierta === l.fuente_id ? null : l.fuente_id); setMarcadas(Object.fromEntries(l.items.map(i => [i.id, true]))); };

  if (!listas.length) return null;
  return (
    <section className="nv" aria-label="Tareas nuevas en tus listas de Notion">
      {listas.map(l => {
        const ids = l.items.map(i => i.id);
        const elegidas = l.items.filter(i => marcadas[i.id]).map(i => i.id);
        const lista = abierta === l.fuente_id;
        return (
          <div className="nv-card" key={l.fuente_id}>
            {l.error ? (
              <p className="nv-t"><b>No se ha podido leer «{l.nombre}».</b> Se reintentará en la próxima sincronización.</p>
            ) : (
              <>
                <p className="nv-t"><b>{num(l.n)} {l.n === 1 ? "tarea nueva" : "tareas nuevas"}</b> en «{l.nombre}»</p>
                <div className="nv-acc">
                  <button type="button" className="mt-b p btn" disabled={ocupada === l.fuente_id} onClick={() => anadir(l, ids)}>
                    {l.n === 1 ? "Añadir la nueva" : `Añadir las ${num(l.n)} nuevas`}</button>
                  <button type="button" className="mt-b btn" aria-expanded={lista} onClick={() => abrir(l)}>{lista ? "Ocultar" : "Elegir cuáles"}</button>
                </div>
                {lista && (
                  <div className="nv-lista">
                    <table className="fn-prev">
                      <caption className="fn-sr">Tareas nuevas de {l.nombre}</caption>
                      <thead><tr><th><span className="fn-sr">Añadir</span></th><th>Título</th><th>Estado</th><th>Prioridad</th><th>Fecha</th></tr></thead>
                      <tbody>
                        {l.items.map(i => (
                          <tr key={i.id}>
                            <td><input type="checkbox" checked={!!marcadas[i.id]} aria-label={`Añadir: ${i.titulo}`}
                              onChange={e => setMarcadas({ ...marcadas, [i.id]: e.target.checked })} /></td>
                            <td><b>{i.titulo}</b></td><td>{ESTADO[i.estado] || "—"}</td><td>{PRIO[i.prioridad] || "—"}</td><td>{diaCorto(i.fecha)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="nv-acc">
                      <button type="button" className="mt-b p btn" disabled={!elegidas.length || ocupada === l.fuente_id} onClick={() => anadir(l, elegidas)}>
                        {elegidas.length === 1 ? "Añadir 1 seleccionada" : `Añadir ${num(elegidas.length)} seleccionadas`}</button>
                      <button type="button" className="mt-b btn" onClick={() => setAbierta(null)}>Ahora no</button>
                    </div>
                  </div>
                )}
              </>
            )}
            {fallo && fallo.id === l.fuente_id && <p className="nv-err" role="alert">{fallo.mensaje}. No se ha añadido nada.</p>}
          </div>
        );
      })}
    </section>
  );
}
